import { render } from "./Main.vue?vue&type=template&id=0666c6c3&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=0666c6c3&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0666c6c3"

export default script